<template>
  <div>
    <base-dialog :show="displayDelete" small>
      <div class="mx-5 my-5">
        <h4 class="text-white">ยืนยันการลบผู้รับเงินนี้</h4>
        <div class="grid grid-cols-12 gap-4 mt-20">
          <vs-button
            class="col-end-9 col-span-4"
            color="#ffffff"
            text-color="#8d9498"
            @click="displayDelete = false"
            >ยกเลิก</vs-button
          >
          <vs-button
            class="col-end-13 col-span-4"
            color="#15c1c3"
            @click="confirmDeleteAccounting"
            >ยืนยัน</vs-button
          >
        </div>
      </div>
    </base-dialog>
    <div class="contentArea">
      <div class="pl-2">
        <div>
          <!-- <topTableButton /> -->
          <!-- <tabComponent /> -->
          <div class="w-full">
            <div class="flex justify-between ml-3 date-filter">
              <div>
                <vs-button
                v-if="permission.setting_add_owner"
                  color="#15c1c3"
                  style="width: 161px;"
                  @click="goToCreateAccounting"
                >
                  <font-awesome-icon icon="plus" class="mr-1" />
                  เพิ่มผู้รับเงิน
                </vs-button>
              </div>
              <div class="flex">
                <div class="search flex items-center">
                  <font-awesome-icon
                    icon="search"
                    class="mr-1"
                    :style="{ color: '#03a9f3' }"
                  />
                  <input
                    type="text"
                    placeholder="Search"
                    v-model="searchTerm"
                  />
                </div>
              </div>
            </div>
            <AgGrid :searchQuery="searchTerm" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "../util/backend.js";
import AgGrid from "./elements/ag-grid-table/AgGridTable";
import { mapGetters } from "vuex";
export default {
  components: {
    AgGrid,
  },
  data() {
    return {
      displayDelete: false,
      deleteId: null,
      searchTerm: "",
    };
  },
  computed: {
    ...mapGetters({ nowSlug: "getNowSlug", tabActive: "general/tabActive" }),
    permission() {
      return this.$store.getters.getPermission;
    },
  },
  methods: {
    async confirmDeleteAccounting() {
      const res = await axios.post(
        `${baseUrl}/accounting/delete?accounting_id=${this.deleteId}`,
        {},
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      console.log(res);
      this.$store.dispatch("general/getTable", "seventh");
      this.displayDelete = false;
    },
    goToCreateAccounting() {
      this.$router.push("/createaccounting");
    },
  },
  mounted() {
    this.$root.$on("delete-modal", (id) => {
      this.displayDelete = true;
      this.deleteId = id;
    });
    // this.$store.dispatch("general/getTab", this.nowSlug);
    this.$store.dispatch(
      "general/getTable",
      this.tabActive.path || this.nowSlug
    );
  },
  watch: {
    tabActive(newValue) {
      this.$store.dispatch("general/getTable", newValue.path);
    },
  },
};
</script>

<style scoped>
p,
h2 {
  color: #dddddd;
}

.search input[type="text"] {
  font-size: 17px;
  border: none;
  border-radius: 2px;
  background-color: #3a3f51;
  width: 100px;
  color: #dddddd;
  padding: 10px 5px;
  transition: width 0.5s;
}

.search input[type="text"]:focus {
  width: 300px;
}

.search {
  padding-left: 10px;
  border-radius: 5px;
  border: solid 1.5px #03a9f3;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #03a9f3;
  opacity: 1; /* Firefox */
}
</style>
